import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'


import { RaService } from '../../../../core';
import { State } from '@progress/kendo-data-query';

@Component({
  selector: 'app-rvrs-create-from-existing',
  templateUrl: './rvrs-create-from-existing.component.html',
  styleUrls: ['./rvrs-create-from-existing.component.scss']
})
export class RvrsCreateFromExistingComponent implements OnInit {

  @Output() rateAuditChosen = new EventEmitter<any>();

  public view:GridDataResult;
  public state:State = {
    skip: 0,
    take: 2000
  };
  public selectedAudit:string[]=[];
  public filteredAccountName;
  public filterStartDate:string;
  public filterEndDate:string;
  public sorted:string = "";
  now: () => DateTime = () => DateTime.now;


  constructor(private raService: RaService) {
    var date = this.now().toJsDate();
    this.filterStartDate = (date.getMonth()+1) + "/" + date.getDate() + "/" + (date.getFullYear()-2);
  }

  ngOnInit(){
    this.raService.query(this.state,this.filterStartDate,this.filterEndDate,this.filteredAccountName)
    .subscribe(data=>{
      this.view = data;
    });
  }

  dataStateChange(state: DataStateChangeEvent): void {

    this.state = state;
    this.state.take=2000;
    this.sorted = "";
    this.sorted = (state.sort.find(e => e.dir === 'asc' || e.dir == 'desc') || { 'field': '' }).field;
    this.raService.query(this.state,this.filterStartDate,this.filterEndDate,this.filteredAccountName)
    .subscribe(data=>{
      this.view = data;
    });
  }

  selectionChange(event){
    let selectedAuditID = event.selectedRows[0].dataItem.AuditID.toString();

    if(selectedAuditID) {
      sessionStorage.setItem('selectedAudit', selectedAuditID);
      //to be implemented - get information from the database and pass it up
      //this might be implemented in the parent component instead of here, in which case
      //this code would not change
      this.rateAuditChosen.emit({inputValid:true, selectedAuditID});
    } else {
      sessionStorage.setItem('selectedAudit', selectedAuditID);
      this.rateAuditChosen.emit({inputValid:false, selectedAuditID});
  }
  }

  getSelectedAudit():string {
    if (this.selectedAudit.length>0) {
      return this.selectedAudit[0];
    }
    return "";
  }

  divMouseEnter($event, item) {
    if(item) {
      item.hovering = true;
  }
    }
  divMouseLeave($event, item) {
    if(item) {
      item.hovering = false;
    }
  }

  returnSelectedAuditID(){
    return this.selectedAudit[0];
  }
  onTemplateClick(e){
    e.target.parentNode.click()
  }

}
